import I18n from 'I18n';
import { useCallback, useState } from 'react';
export const useFaqToggleHandler = onFaqInteraction => {
  const [__openFaqs, setOpenFaqs] = useState(new Set());
  const handleToggle = useCallback((questionKey, questionTextKey) => {
    setOpenFaqs(prev => {
      const isOpen = prev.has(questionKey);
      if (onFaqInteraction) {
        onFaqInteraction({
          action: isOpen ? 'closed' : 'opened',
          value: I18n.text(questionTextKey, {
            locale: 'en-us'
          }),
          questionKey
        });
      }
      const newSet = new Set(prev);
      if (isOpen) {
        newSet.delete(questionKey);
      } else {
        newSet.add(questionKey);
      }
      return newSet;
    });
  }, [onFaqInteraction]);
  return handleToggle;
};
export const useLinkClickHandler = onLinkClick => {
  return useCallback((name, url, type = 'external') => {
    if (onLinkClick) {
      onLinkClick({
        name,
        url,
        type
      });
    }
  }, [onLinkClick]);
};